/*
 * Minha conta — alterna entre a lista de pedidos e o detalhe de um pedido.
 *
 * O Liquid não lê a query string, então a seção já entrega um painel escondido
 * por pedido da página. Aqui só mostramos o de ?pedido=<id> e mantemos o botão
 * voltar do navegador funcionando (pushState + popstate).
 *
 * Também cuida de dois atalhos do detalhe: copiar o código de rastreio e
 * "Comprar de novo" (Cart AJAX API, depois vai para o carrinho).
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-yasy-conta]');
  if (!raiz) return;

  var lista = raiz.querySelector('[data-conta-lista]');
  var paineis = raiz.querySelectorAll('[data-conta-pedido]');
  if (!lista) return;

  function pedidoDaUrl() {
    return new URLSearchParams(window.location.search).get('pedido');
  }

  function mostrar(id, rolarPara) {
    var painel = id ? raiz.querySelector('[data-conta-pedido="' + id + '"]') : null;

    paineis.forEach(function (p) { p.hidden = p !== painel; });
    lista.hidden = !!painel;

    if (painel) {
      window.scrollTo({ top: raiz.offsetTop - 80 });
      var titulo = painel.querySelector('h1');
      if (titulo) titulo.focus({ preventScroll: true });
    } else if (rolarPara) {
      var cartao = lista.querySelector('[data-conta-abrir="' + rolarPara + '"]');
      if (cartao) cartao.closest('li').scrollIntoView({ block: 'center' });
    }
  }

  function urlCom(id) {
    var url = new URL(window.location.href);
    if (id) url.searchParams.set('pedido', id);
    else url.searchParams.delete('pedido');
    return url.pathname + url.search;
  }

  raiz.addEventListener('click', function (evento) {
    var abrir = evento.target.closest('[data-conta-abrir]');
    if (abrir) {
      evento.preventDefault();
      var id = abrir.getAttribute('data-conta-abrir');
      history.pushState({ pedido: id }, '', urlCom(id));
      mostrar(id);
      return;
    }

    var voltar = evento.target.closest('[data-conta-voltar]');
    if (voltar) {
      evento.preventDefault();
      var atual = pedidoDaUrl();
      history.pushState({}, '', urlCom(null));
      mostrar(null, atual);
      return;
    }

    var copiar = evento.target.closest('[data-conta-copiar]');
    if (copiar && navigator.clipboard) {
      navigator.clipboard.writeText(copiar.getAttribute('data-conta-copiar')).then(function () {
        var rotulo = copiar.getAttribute('aria-label');
        copiar.setAttribute('aria-label', 'Código copiado');
        copiar.classList.add('text-secondary');
        setTimeout(function () {
          copiar.setAttribute('aria-label', rotulo);
          copiar.classList.remove('text-secondary');
        }, 1800);
      });
      return;
    }

    var recomprar = evento.target.closest('[data-conta-recomprar]');
    if (recomprar) {
      var texto = recomprar.querySelector('[data-conta-recomprar-rotulo]');
      var itens;
      try { itens = JSON.parse(recomprar.getAttribute('data-conta-recomprar')); } catch (e) { return; }

      recomprar.disabled = true;
      texto.textContent = 'Adicionando…';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: itens })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        })
        .catch(function () {
          recomprar.disabled = false;
          texto.textContent = 'Algum item acabou. Tente pelo produto';
        });
    }
  });

  window.addEventListener('popstate', function () { mostrar(pedidoDaUrl()); });

  mostrar(pedidoDaUrl());
})();
